import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import NumberUtils from '../../utils/NumberUtils';
import BrowserUtils from '../../utils/BrowserUtils';
import InternetBankingActions from '../../actions/InternetBankingActions';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';

class SavingPotsRejig extends Component {
  constructor(props) {
    super(props);

    this.getReducePotPage = this.getReducePotPage.bind(this);
    this.handleMoveMoney = this.handleMoveMoney.bind(this);
  }

  componentDidMount() {
    BrowserUtils.isMobileView() && SiteHeaderActionCreator.hideHeaderFlag(true);
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.hideHeaderFlag(false);
  }

  getReducePotPage() {
    SavingPotsActionCreator.getReducePotPage(this.props.pots);
  }

  handleMoveMoney(e) {
    //  - Move money - transfer to payment page
    SavingPotsActionCreator.handleMoveMoney({
      id: this.props.getSelectedAccountID,
    });
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
    e.preventDefault();
  }

  render() {
    const { content, unallocatedAmount } = this.props;

    const unAmount = NumberUtils.appendCurrency(
      '{}',
      Math.abs(unallocatedAmount)
    );
    return (
      <div className="savingPotsRejig__wrapper">
        <div className="savingPotsRejig text-center">
          <div className="rejig__image">
            <img src="../images/b/gingerbread-man.png" alt="" />
          </div>
          <div className="rejig_content">
            <h2>{content.savingPotRejigTitle}</h2>
            <p>
              {content.savingpotRejigMessage1} <strong>{unAmount}</strong>{' '}
              {content.savingpotRejigMessage2}
            </p>
            <div className="rejig_btn">
              <a
                href="javascript:void(0)"
                className="page-options border opt-green"
                type="button"
                onClick={this.getReducePotPage}
              >
                {content.savingPotReduceRejigButton}
              </a>
              <a
                href="javascript:void(0)"
                className="page-options border opt-green"
                type="button"
                onClick={this.handleMoveMoney}
              >
                {content.savingPotMoveMoneyButton2}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SavingPotsRejig.propTypes = {
  unallocatedAmount: PropTypes.number,
  pots: PropTypes.array,
  content: PropTypes.object,
  getSelectedAccountID: PropTypes.string,
};

export { SavingPotsRejig };
